import { ChangeDetectionStrategy, Component } from '@angular/core'
import { UsageBillingScenario } from '../../mocks/showcase-usage-billing-mocks'
import { TestPageMockState } from '../../showcase-mock-state'

/**
 * The real Usage & Billing dashboard against a patched loadDashboard. The active
 * scenario key lives on the shared state because the patch reads it on every call.
 */
@Component({
  selector: 'showcase-usage-billing',
  templateUrl: './showcase-usage-billing.component.html',
  styleUrls: ['./showcase-usage-billing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseUsageBillingComponent {
  usageBillingMounted = true

  constructor(private readonly state: TestPageMockState) {}

  get usageBillingScenarioKey(): string {
    return this.state.usageBillingScenarioKey
  }

  get usageBillingActiveScenario(): UsageBillingScenario {
    return this.state.usageBillingActiveScenario
  }

  get usageBillingScenarioGroups(): { group: string; label: string; scenarios: UsageBillingScenario[] }[] {
    const labelFor: Record<UsageBillingScenario['group'], string> = {
      CONTRACT: 'Contract state',
      CYCLE: 'Billing cycle',
      DATA: 'Data availability',
      SCALE: 'Scale & shape',
      LIFECYCLE: 'Loading & errors',
    }
    const groups: { group: string; label: string; scenarios: UsageBillingScenario[] }[] = []
    for (const scenario of this.state.usageBillingScenarios) {
      const existing = groups.find((g) => g.group === scenario.group)
      if (existing) existing.scenarios.push(scenario)
      else groups.push({ group: scenario.group, label: labelFor[scenario.group], scenarios: [scenario] })
    }
    return groups
  }

  setUsageBillingScenario(key: string): void {
    if (this.state.usageBillingScenarioKey === key) return
    this.state.usageBillingScenarioKey = key
    // The header's contract facts read AccountService rather than the view model, so
    // the patched entitlement has to be restamped before the component remounts.
    this.state.applyScenarioEntitlement()
    // Unmount, then remount next tick so ngOnInit re-runs against the new scenario
    // and the outgoing instance's ResizeObservers / D3 tear down.
    this.usageBillingMounted = false
    setTimeout(() => (this.usageBillingMounted = true), 0)
  }
}
